/** Risk factor types for the trade copier setSettings API (Duplikium). */
export const COPY_RISK_FIXED_LOT = 4;
export const COPY_RISK_MULTIPLIER_LOT = 11;
export const COPY_RISK_AUTO_BALANCE = 1;

export const RISK_UI_FIXED_LOT = "fixed_lot";
export const RISK_UI_MULTIPLIER = "multiplier";
export const RISK_UI_RISK_PERCENT = "risk_percent";

export const RISK_FACTOR_OPTIONS = [
  { value: RISK_UI_FIXED_LOT, label: "Fixed lot size" },
  { value: RISK_UI_MULTIPLIER, label: "Multiplier (lot)" },
  { value: RISK_UI_RISK_PERCENT, label: "Risk % (auto balance)" },
];

export function defaultRiskValueForType(riskManagement) {
  if (riskManagement === RISK_UI_MULTIPLIER) return "1";
  if (riskManagement === RISK_UI_RISK_PERCENT) return "1";
  return "0.01";
}
